import React from 'react'

import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import ComplianceTypeDropdown from '../../_shared/ComplianceTypeDropdown'
import EntityDropdown from './EntityDropdown'
import GroupedNonCompliancesLoader from './_load/GroupedNonCompliancesLoader'
import List from './List'
import PeriodDescription from '../../_shared/PeriodDescription'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import WidgetWrapper from '../../WidgetWrapper'

const Widget = props => {
  const { widget } = props

  return (
    <WidgetWrapper {...props}>
      <Grid justify="space-between" gap={1}>
        <Col>
          <Title size="h5" noMargin>
            {widget.name}
          </Title>
          <PeriodDescription />
        </Col>
        <Col flex={1} />
        <EntityDropdown />
        <ComplianceTypeDropdown />
      </Grid>

      <Separator weight={2} />
      <GroupedNonCompliancesLoader>
        <List widget={widget} />
      </GroupedNonCompliancesLoader>
    </WidgetWrapper>
  )
}

export default Widget
